var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBoxShipping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 8 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7 11v9l8 3 8-3v-9l-8-3zm2.086.285L15 9.068l2.204.827-5.909 2.216zm6.571 2.454-2.317-.866 5.905-2.214 2.331.874-5.925 2.223zM8 19.307v-7.359l2.911 1.086v2.433l1.905.713v-2.435L15 14.56v7.371zm10-3.432 3-1.125v3l-3 1.125z"
})));
export default SvgBoxShipping;